import ReactPaginate from 'react-paginate';
import PropTypes from 'prop-types';
import GetIcon from '../../utils/Icon';

const Pagination = ({ 
  setCurrentPage, 
  totalRecords, 
  pageSize, 
  currentPage = 1,
  className = '',
  showPageInfo = true
}) => {
  const handlePageChange = (selectedPage) => {
    const page = selectedPage.selected + 1;
    setCurrentPage(page);
  };

  const pageCount = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalRecords);

  return (
    <div className={`container-fluid d-flex justify-content-between align-items-center ${className}`}>
      {showPageInfo && (
        <div>
          <p style={{ color: "#4b002b", fontSize: "0.8rem" }}>
            Showing {startItem} to {endItem} of {totalRecords} entries
          </p>
        </div>
      )}
      
      {pageCount > 1 && (
        <ReactPaginate
          previousLabel={
            <GetIcon iconName="FaAnglesLeft" color="#E6A744" size={13} />
          }
          nextLabel={
            <GetIcon iconName="FaAnglesRight" color="#E6A744" size={13} />
          }
          containerClassName="pagination mb-0"
          breakClassName="page-item"
          activeClassName="active"
          pageClassName="page-item"
          forcePage={currentPage - 1}
          breakLabel={"..."}
          pageRangeDisplayed={5}
          marginPagesDisplayed={2}
          pageCount={pageCount}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};

Pagination.propTypes = {
  setCurrentPage: PropTypes.func.isRequired,
  totalRecords: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  currentPage: PropTypes.number,
  className: PropTypes.string,
  showPageInfo: PropTypes.bool,
};

export default Pagination;